import { useState } from 'react';
import { AppProvider, useApp } from './state/AppContext.js';
import { Layout } from './components/Layout.js';
import { ToastContainer } from './components/ToastContainer.js';
import { WelcomeConfigModal } from './components/WelcomeConfigModal.js';
import { InviteGate } from './components/InviteGate.js';
import { ROUTE_VIEWS } from './views/index.js';
import { loadOnboarded, saveOnboarded } from './state/persistence.js';

function CurrentView() {
  const { state } = useApp();
  const View = ROUTE_VIEWS[state.route];
  return <View />;
}

function Onboarding() {
  // Slice 8 起前端不收集凭证，欢迎弹窗只剩输出位置 + 架构说明；首访弹一次。
  const [open, setOpen] = useState<boolean>(() => !loadOnboarded());
  return (
    <WelcomeConfigModal
      open={open}
      onClose={() => { saveOnboarded(); setOpen(false); }}
    />
  );
}

export function App() {
  return (
    <AppProvider>
      <InviteGate>
        <Layout>
          <CurrentView />
        </Layout>
        <Onboarding />
      </InviteGate>
      <ToastContainer />
    </AppProvider>
  );
}
